import styled, { css } from 'styled-components';
import { pxToRem } from '@anwb/style-utilities';
import Typography from '@anwb/typography';
/**
 * This value is explicitly defined here, because the border radius must use this value too.
 */
const PROGRESS_BAR_HEIGHT = 10;
/**
 * Progress Container
 */
export const progressContainerStyles = ({ theme }) => css `
	display: flex;
	flex-direction: row;
	flex-flow: nowrap;
	align-items: center;
	width: 100%;
	margin-bottom: ${pxToRem(theme.spacing['100'])};
`;
export const ProgressContainer = styled.div `
	${progressContainerStyles}
`;
/**
 * Progress Value
 */
export const progressValueStyles = ({ theme }) => css `
	color: ${theme.colors.base.textBody};
	flex: 0 1 auto;
	margin-right: ${pxToRem(theme.spacing['200'])};
`;
export const ProgressValue = styled(Typography).attrs({
    variant: 'body-text',
    tagName: 'div',
}) `
	${progressValueStyles}
`;
/**
 * Progress Bar
 */
export const progressBarStyles = ({ theme }) => css `
	flex: 1 1 auto;
	align-items: stretch;
	display: flex;
	width: 100%;
	height: ${pxToRem(PROGRESS_BAR_HEIGHT)};
	border-radius: ${pxToRem(PROGRESS_BAR_HEIGHT)};
	background: ${theme.colors.medium.bgProgressBar};
`;
export const ProgressBar = styled.div `
	${progressBarStyles}
`;
/**
 * Progress Bar Inner
 */
export const progressBarInnerStyles = ({ theme, $isFull, $percentage, }) => css `
	height: 100%;
	background: ${theme.colors.highlight.fillProgressBar};
	border-radius: ${pxToRem(PROGRESS_BAR_HEIGHT)} 0 0 ${pxToRem(PROGRESS_BAR_HEIGHT)};
	width: ${$percentage}%;

	${$isFull &&
    css `
		border-radius: ${pxToRem(PROGRESS_BAR_HEIGHT)};
	`}
`;
export const ProgressBarInner = styled.div `
	${progressBarInnerStyles}
`;
//# sourceMappingURL=progress.styled.js.map